import { useEffect, useRef } from 'react'

import { SkillFrom } from '../interface'

import { SkillIFrame } from './SkillIFrame'
import { useSkillHandler } from './useSkillHandler'

export interface SkillProps {
  customer?: { session: string }
  from: SkillFrom
  id: string
  params?: Record<string, unknown>
  preview?: boolean
  src: string
}

const skillInitRetryDelays = [250, 1000]

export function Skill({ src, id, customer, params, preview, from }: SkillProps) {
  const { $skillRef, height } = useSkillHandler({ id })
  const retryTimers = useRef<number[]>([])
  const postSkillInit = () => {
    $skillRef?.current?.contentWindow?.postMessage(
      {
        type: 'init',
        _id: id,
        customer,
        params,
        skillParams: {
          from,
          preview,
        },
      },
      '*'
    )
  }
  const clearRetryTimers = () => {
    retryTimers.current.forEach(timer => window.clearTimeout(timer))
    retryTimers.current = []
  }
  const handleSkillLoad = () => {
    clearRetryTimers()
    postSkillInit()
    retryTimers.current = skillInitRetryDelays.map(delay => window.setTimeout(postSkillInit, delay))
  }

  useEffect(() => clearRetryTimers, [])

  return (
    <SkillIFrame
      $skillRef={$skillRef}
      height={height}
      src={src}
      handleSkillLoad={handleSkillLoad}
    />
  )
}
